<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>支付赠送代金券</span>
      </div>

      <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini">
        <el-form-item label="活动名称">
          <el-input v-model="formSearch.name" placeholder="活动名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getActivity">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="handleOpen">创建活动</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" size="mini">
        <el-table-column prop="id" abel="活动模板ID" width="90">
        </el-table-column>
        <el-table-column prop="name" label="活动名称">
        </el-table-column>
        <el-table-column label="活动时间">
          <template slot-scope="scope">
            <span>{{formatActiviDate(scope.row.starttime)}}</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{formatActiviDate(scope.row.endtime)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jackpot" label="奖池金额" width="100">
        </el-table-column>
        <el-table-column prop="give" label="已赠金额" width="80">
        </el-table-column>
        <el-table-column prop="state" label="状态" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.state =='1'">待上线</span>
            <span v-if="scope.row.state =='2'">已上线</span>
            <span v-if="scope.row.state =='3'">已结束</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">详情预览</el-button>
            <el-divider v-if="scope.row.state === '1'" direction="vertical"></el-divider>
            <el-button v-if="scope.row.state === '1'" type="text" size="small" @click="handleLineClick(scope.row)">上线</el-button>
            <el-divider v-if="scope.row.state === '2'" direction="vertical"></el-divider>
            <el-button v-if="scope.row.state === '2'" type="text" size="small" @click="handleUnLineClick(scope.row)">下线</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="float:right;margin:10px" @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageresult.pageSize"
        layout="total, prev, pager, next"
        :total="pageresult.totalSize">
      </el-pagination>
    </el-card>

    <el-drawer :visible.sync="drawerShow" :with-header="false" size="80%">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>活动详情</span>
        </div>
        <el-steps :active="activeShow" simple>
          <el-step title="第1步 活动内容" icon="el-icon-circle-plus"></el-step>
          <el-step title="第2步 赠送代金券内容" icon="el-icon-collection-tag"></el-step>
        </el-steps>

        <div v-show="activeShow === 0">
          <el-form label-width="auto" size="mini">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="showForm.name"></el-input>
            </el-form-item>
            <el-form-item label="活动备注" prop="remarks">
              <el-input type="textarea" v-model="showForm.remarks"></el-input>
            </el-form-item>
            <el-form-item label="活动时间" prop="activitydate">
              <el-date-picker
                v-model="showForm.activitydate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="奖池金额" prop="jackpot">
              <el-input type="number" v-model="showForm.jackpot"></el-input>
            </el-form-item>
            <el-form-item label="参与次数" prop="limitnext">
              <el-radio-group v-model="showForm.limitnext">
                <el-radio :label="1">每个用户<el-input-number v-model="showForm.usernext" :controls="false" style="width:40px"></el-input-number>次</el-radio>
                <el-radio :label="2">每个用户每天<el-input-number v-model="showForm.userdaynext" :controls="false" style="width:40px"></el-input-number>次</el-radio>
                <el-radio :label="3">不限次数</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="next2">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="activeShow === 1">
          <el-form label-width="auto" size="mini">
            <el-form-item label="代金券礼包设置">
              <el-table :data="showForm.couponRule" size="mini">
                <el-table-column prop="startDenomin" label="起止金额" width="80">
                </el-table-column>
                <el-table-column prop="endDenomin" label="截止金额" width="80">
                </el-table-column>
                <el-table-column prop="denomin" label="面额" width="60">
                </el-table-column>
                <el-table-column prop="second" label="消费次数" width="80">
                  <template slot-scope="scope">
                    {{scope.row.second === -1?'不限次':scope.row.second}}
                  </template>
                </el-table-column>
                <el-table-column prop="quota" label="消费金额门槛" width="100">
                </el-table-column>
                <el-table-column prop="range" label="应用范围" width="100">
                </el-table-column>
                <el-table-column prop="activityDate" label="有效时间">
                  <template slot-scope="scope">
                    <span>{{formatActiviDate(scope.row.startDate)}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{formatActiviDate(scope.row.endDate)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="activityDate" label="操作" width="150">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.range == '指定应用'" @click="handleShowApplyClick(scope.row.applyList)" type="text" size="small">查看应用</el-button>
                    <el-button @click="handleShowModelClick(scope.row.modelData)" type="text" size="small">查看机型</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item>
              <el-button @click="next2">上一步</el-button>
            </el-form-item>
          </el-form>
        </div>

        </el-card>
    </el-drawer>


    <el-drawer :visible.sync="drawer" :with-header="false" size="60%">
      <el-card shadow="never" class="drawer_body_100">
        <div slot="header" class="clearfix">
          <span>营销活动</span>
        </div>
        <el-steps :active="active" simple>
          <el-step title="第1步 活动内容" icon="el-icon-circle-plus"></el-step>
          <el-step title="第2步 赠送代金券内容" icon="el-icon-collection-tag"></el-step>
        </el-steps>

        <div v-show="active === 0">
          <el-form :model="ruleForm" :rules="rules" ref="ruleFormOne" label-width="auto" size="mini">
            <el-form-item label="活动名称" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="活动备注" prop="remarks">
              <el-input type="textarea" v-model="ruleForm.remarks"></el-input>
            </el-form-item>
            <el-form-item label="活动时间" prop="starttime">
              <el-date-picker
                v-model="ruleTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="handleRuleTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="奖池金额" prop="jackpot">
              <el-input type="number" v-model="ruleForm.jackpot"></el-input>
            </el-form-item>
            <el-form-item label="参与次数" prop="limitnext">
              <el-radio-group v-model="ruleForm.limitnext">
                <el-radio label="1">每个用户<el-input-number v-model="ruleForm.usernext" :controls="false" style="width:40px"></el-input-number>次</el-radio>
                <el-radio label="2">每个用户每天<el-input-number v-model="ruleForm.userdaynext" :controls="false" style="width:40px"></el-input-number>次</el-radio>
                <el-radio label="3">不限次数</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="next">下一步</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="active === 1">
          <el-form :model="ruleForm" :rules="rules2" ref="ruleFormTwo" label-width="auto" size="mini">
            <el-form-item label="代金券礼包设置" prop="couponRule">
              <el-button type="info" @click="addRow">添加代金券规则</el-button>
              <el-table :data="ruleForm.couponRule" style="width: 100%" size="mini">
                <el-table-column prop="denomin" label="面额"></el-table-column>
                <el-table-column prop="second" label="消费次数"></el-table-column>
                <el-table-column prop="quota" label="消费金额门槛"></el-table-column>
                <el-table-column prop="range" label="消费应用范围"></el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="delRowClick(scope.$index, scope.row)" type="text" size="small">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>

            <el-form-item>
              <el-button @click="next">上一步</el-button>
              <el-button type="primary" @click="submitForm">提交</el-button>
            </el-form-item>
          </el-form>
        </div>

        </el-card>
    </el-drawer>

    <!-- 代金券消费规则设置 -->
    <el-dialog title="代金券消费规则设置" :visible.sync="dialogVisible" :before-close="handleClose" width="50%">
      <el-form :model="couponForm" :rules="couponFormRules" ref="couponForm" label-width="auto" size="mini">
        <el-form-item label="起止金额" prop="startDenomin">
          <el-input v-model="couponForm.startDenomin">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="截止金额" prop="endDenomin">
          <el-input v-model="couponForm.endDenomin">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="代金券面额" prop="denomin">
          <el-input v-model="couponForm.denomin">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="消费次数设置" prop="secondState">
          <el-radio-group v-model="couponForm.secondState" @change="onSecondRange">
            <el-radio label="0">消费<el-input-number type="number" v-model="couponForm.second" :controls="false" style="width:50px"></el-input-number>次</el-radio>
            <el-radio label="-1">不限次数</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消费金额门槛" prop="quota">
          <el-input v-model="couponForm.quota"></el-input>
        </el-form-item>
        <el-form-item label="有效时间设置" prop="startDate">
          <el-date-picker
            v-model="ruleCouponTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleRuleCouponTime">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="消费应用范围" prop="range">
          <el-radio-group v-model="couponForm.range" @change="onRange">
            <el-radio label="全平台应用"></el-radio>
            <el-radio label="指定应用"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导入应用" v-show="couponForm.flag">
          <el-upload
            :action="`${this.$store.state.upBaseUrl}coupon-market/activity/fileUpload`"
            :headers="myHeaders"
            :limit="1"
            ref="upload"
            accept=".txt"
            :on-success="handleAvatarSuccess"
            :auto-upload="true">
            <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传txt文件，每次只能上传一个文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="指定机型">
          <sam-phone-model @setPhoneModel="setPhoneModel" ref="childModel"></sam-phone-model>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTableRow">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="机型列表" :visible.sync="dialogTableVisible">
      <el-table ref="multipleTable" tooltip-effect="dark" :data="phoneData">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column property="phoneModel" label="机型"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="selectionModel">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 查看机型 -->
    <el-dialog title="机型列表" :visible.sync="dialogModelTableVisible">
      <el-link type="info" v-for="model in modelData"  key="index">【{{model.phoneModel}}】</el-link>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogModelTableVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看应用 -->
    <el-dialog title="查看应用" :visible.sync="dialogApplyVisible">
      <el-link type="info" v-for="apply in applyData" key="index">【{{apply.applyNo}}{{apply.applyName}}】</el-link>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogApplyVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PhoneModel from '../components/phoneModel'
import moment from 'moment'
export default {
  components:{
      'sam-phone-model':PhoneModel
  },
  data () {
    return {
      myHeaders:{},
      ruleTime:[],
      ruleCouponTime:[],
      applyData:[],
      modelData:[],
      dialogApplyVisible:false,
      dialogModelTableVisible:false,
      dialogVisible:false,
      dialogTableVisible:false,
      active:0,
      activeShow:0,//查看用
      tableData:[],
      phoneData:[],//机型列表
      pageresult:{},
      showForm:{},//查看用
      ruleForm: {
        name: '',
        remarks: '',
        range: '',
        waygive: '',
        starttime: '',
        endtime: '',
        jackpot: '',
        limitnext: '',
        usernext: '',
        userdaynext: '',
        platform: '',
        payment: '',
        calculation: '',
        label: '',
        section:[],
        flag:false,//控制是否显示导入应用
        couponRule:[],//代金券礼包设置
      },
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        range: [
          { required: true, message: '请选择应用范围', trigger: 'change' }
        ],
        waygive: [
          { required: true, message: '请选择赠送方式', trigger: 'change' }
        ],
        starttime: [
          { required: true, message: '请选择活动时间', trigger: 'change' }
        ],
        jackpot: [
          { required: true, message: '请输入奖池金额', trigger: 'blur' }
        ],
        limitnext: [
          { required: true, message: '请选择参与次数', trigger: 'change' }
        ]
      },
      rules2: {
        platform: [
          { required: true, message: '请选择活动平台', trigger: 'change' }
        ],
        payment: [
          { required: true, message: '请选择支付方式', trigger: 'change' }
        ],
        calculation: [
          { required: true, message: '请选择计算方式', trigger: 'change' }
        ],
        label: [
          { required: true, message: '请输入活动标签文案', trigger: 'blur' }
        ],
        couponRule: [
          { required: true, message: '请设置优惠券规则', trigger: 'change' }
        ]
      },
      couponForm: {
        flag: false,
        startDenomin:'',
        endDenomin:'',
        denomin: '',
        second: '',
        secondState: '',
        quota:'',
        range:'',
        applyList:[],//指定应用时 上传的应用列表
        modelData:[],//已选机型列表
        startDate:'',
        endDate:''
      },
      couponFormRules: {
        startDenomin: [
          { required: true, message: '请输入代金券起止金额', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        endDenomin: [
          { required: true, message: '请输入代金券截止金额', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        denomin: [
          { required: true, message: '请输入代金券面额', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        secondState: [
          { required: true, message: '请选择消费次数', trigger: 'change' }
        ],
        quota: [
          { required: true, message: '请输入消费金额门槛', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        startDate: [
          { required: true, message: '请选择有效时间', trigger: 'blur' }
        ],
        range: [
          { required: true, message: '请选择应用范围', trigger: 'change' }
        ]
      },
      drawer: false,
      drawerShow: false,
      formSearch: {
        name: '',
        pageNum:1
      }
    }
  },
  created(){
    var token =  window.sessionStorage.getItem('token');
    this.myHeaders = {'oa-token':token}
    this.getActivity();
  },
  methods: {
    setPhoneModel(models){
      this.couponForm.modelData = models;
    },
    handleShowApplyClick(data){
      this.applyData = data;
      this.dialogApplyVisible = true;
    },
    handleShowModelClick(data){
      this.modelData = data;
      this.dialogModelTableVisible = true;
    },
    onRange(value){
      if (value === "指定应用") {
        this.couponForm.flag = true;
      }else {
        this.couponForm.flag = false;
      }
    },
    onSecondRange(val){
      if (val === "-1") {
        this.couponForm.second = "-1";
      }
    },
    addTableRow(){
      let _this = this;
      this.$refs.couponForm.validate((valid) => {
        if (valid) {
          let row = Object.assign({},_this.couponForm);//Object.create(_this.couponForm);
          _this.ruleForm.couponRule.push(row);
          _this.resetFormCoupon("couponForm");
          _this.dialogVisible = false;
        } else {
          _this.$message.error('error submit!!');
          return false;
        }
      });
    },
    handleClose(done) {
      this.resetFormCoupon("couponForm");
      this.dialogVisible = false;
    },
    handleClick(row){
      this.drawerShow = true;
      this.showForm = row;
      this.showForm.activitydate = [row.starttime,row.endtime];
    },
    handleUnLineClick(row){
      let that = this;
      this.$confirm('此下线操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$ajax({
            url:"coupon-market/activity/saveGoUnLine",
            async:false,
            methods:'GET',
            data:{'id':row.id},
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.getActivity();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        });
    },
    handleLineClick(row){
      let that = this;
      this.$confirm('此上线操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$ajax({
            url:"coupon-market/activity/saveGoLine",
            async:false,
            methods:'GET',
            data:{'id':row.id},
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.getActivity();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        });
    },
    saveRowClick(row){
      row.flag=false;
    },
    editRowClick(row){
      row.flag=true;
    },
    delRowClick(index,row){
      this.ruleForm.couponRule.splice(index,1);
    },
    addRow(){
      this.dialogVisible = true;
      // let row = {'startamount':0,'endamount':0,'donationamount':0,'flag':true};
      // this.ruleForm.section.push(row);
    },
    next() {
      this.$refs.ruleFormOne.validate((valid) => {
        if (valid) {
          if (this.active++ > 0) this.active = 0;
        } else {
          this.$message.error('error next!!');
          return false;
        }
      });
    },
    next2() {
      if (this.activeShow++ > 0) this.activeShow = 0;
    },
    handleCurrentChange(val) {
      this.formSearch.pageNum=val;
      this.getActivity();
    },
    handleOpen() {
      this.drawer=true
    },
    formatActiviDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    formatDate(row, column) {
      return moment(row.createdate).format("YYYY-MM-DD HH:mm");
    },
    submitForm(){
      let that = this;
      this.$refs.ruleFormTwo.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-market/activity/saveActivity",
            async:false,
            methods:'POST',
            data:that.ruleForm,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                that.resetForm("ruleFormOne");
                that.resetForm("ruleFormTwo");
                // that.ruleForm = {'section':[]};
                that.drawer = false;
                that.active = 0;
                that.getActivity();
              }else{
                that.$message.error(response.message);
              }
            },
            error:function(){
              that.$message.error("请求失败");
            }
          })
        } else {
          that.$message.error('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleTime = [];
      this.ruleForm.usernext = '';
      this.ruleForm.userdaynext = '';
      this.$refs[formName].resetFields();
    },
    resetFormCoupon(formName) {
      this.ruleCouponTime = [];
      this.couponForm.secondState = '';
      this.couponForm.second = '';
      this.$refs.upload.clearFiles();
      this.$refs.childModel.handleClear();
      this.$refs[formName].resetFields();
    },
    getActivity(){
      let _this = this;
      let info = this.$store.state.userInfo;
      _this.formSearch.czybh = info.userbh;
      this.$ajax({
        url:"coupon-market/activity/getActivityPage",
        async:false,
        data:_this.formSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            _this.tableData=response.data.content;
            _this.pageresult = response.data;
          }else{
            _this.$message.error(response.message);
          }
        }
      })
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.couponForm.applyList=res.data
        this.$alert('上传成功!', '提示', {
          confirmButtonText: '确定',
        });
      }
    },
    openPhoneModel(){
      let _this = this;
      if(this.phoneData.length == 0){
        this.$ajax({
          url:"coupon-system/data/phoneModel",
          async:false,
          token:window.sessionStorage.getItem('token'),
          success:function(response){
            if (response.code == 0) {
              _this.phoneData = response.data;
              _this.dialogTableVisible = true;
            }else{
              _this.$message.error(response.message);
            }
          },
          error:function(){
            _this.$message.error("请求失败");
          }
        })
      }else{
        this.dialogTableVisible = true;
      }

    },
    selectionModel(){
      let data = this.$refs.multipleTable.selection || [];
      let models = Object.assign([],data);
      this.couponForm.modelData = models;//Object.assign();
      this.dialogTableVisible = false;
    },
    handleRuleTime(){
      if (this.ruleTime != null) {
				this.ruleForm.starttime = this.ruleTime[0];
				this.ruleForm.endtime = this.ruleTime[1];
			}
    },
    handleRuleCouponTime(){
      this.couponForm.startDate = this.ruleCouponTime[0];
      this.couponForm.endDate = this.ruleCouponTime[1];
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/merch/mer_activity.vue